import { ETipoVisualizacao } from "../../../../@types/IntegracaoCampoEnum";
import type { TIntegracaoCampoModel } from "../../../../@types/IntegracaoCampoModel";

export default function useFieldLayout() {
  const layoutType = (field: TIntegracaoCampoModel): ETipoVisualizacao => {
    return field.tipo as unknown as ETipoVisualizacao;
  };

  return {
    layoutType
  };
}
